import { useApplicationModals } from "app/common/hooks";
import { useCreateForm } from "app/integration/common/hooks";
import * as Yup from "yup";
import api from "app/integration/api";
import { ModalMolecule } from "app/components/molecules/modal";
import { Formik } from "formik";
import { Button, OutlineButton } from "app/components/atoms/button";
import AppModals from ".";
import * as XLSX from 'xlsx';
import { Badge } from "app/components/atoms/badge";
import { useState } from "react";

function ImportSalesOrderWeb({ onSuccess = () => { } }) {
  const { showStates, closeModal } = useApplicationModals();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    closeModal("salesOrder.importweb");
    setFailedData([]); setProcessedData([])
  };
  const handleSuccess = () => {
    // closeModal("salesOrder.importweb");
    onSuccess();
  };

  var isError = false;

  const { openModal, setPayloads } = useApplicationModals();
  const [data, setData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const [failedData, setFailedData] = useState([]);

  const excelDateToJSDate = (excelDate) => {
    const excelEpoch = new Date(1899, 11, 30); // Excel epoch (30 Dec 1899)
    const msPerDay = 24 * 60 * 60 * 1000; // Konversi hari ke milidetik

    return new Date(excelEpoch.getTime() + excelDate * msPerDay);
  }

  const { initialValues, validationSchema, onSubmit } = useCreateForm({
    initialValues: {
      id: null,
      fileImport: "",
      data: {},
    },
    validationSchema: Yup.object().shape({
      fileImport: Yup.mixed().required("File harus diisi")
        .test('fileFormat', 'Only Excel files are allowed', value => {
          if (value) {
            const supportedFormats = ['xlsx', 'xls', 'csv'];
            return supportedFormats.includes(value.name.split('.').pop());
          }
          return true;
        })
        .test('fileSize', 'File size must be less than 3MB', value => {
          if (value) {
            return value.size <= 3145728;
          }
          return true;
        }),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        setFailedData([]); setProcessedData([]);
        // Assuming `data` is the sheet data
        for (let i = 0; i < data.length; i++) {
          const temp = { ...data[i], index: i + 1 };
          console.log("temp: ", temp);

          // Simulate processing and possible failure
          // const isSuccess = Math.random() > 0.2; // 80% chance of success
          try {
            const importData = await api.salesOrder.import(
              temp.order_date,
              Number(temp.shipping_cost) || 0,
              2,
              temp.order_id,
              "WEBSITE",
              Number(temp.total) || 0,
              null,
              0,
              temp.customer_name,
              null,
              temp.paid_date,
              temp.order_date,
              temp.items.map(item => ({
                product_name: item.product_name,
                unit_price: Number(item.price) || 0,
                qty: Number(item.qty) || 0,
                discount_reseller: Number(item.product_discount) || 0,
              })),
            );

            if (importData?.status === "success") {
              setProcessedData(prevData => [...prevData, temp]); // Add the processed row to the state
            } else {
              throw new Error(`Import failed for row ${i + 1}`);
            }
          } catch (error) {
            temp.errorMessage = error?.response?.data?.message;
            setFailedData(prevFailed => [...prevFailed, temp]); // Store failed row
          }
        }
        const responseOrderStatus = await api.salesOrder.updateDeliveryOrderStatus();
        if (responseOrderStatus?.status !== "success") {
          throw new Error(`Failed to update delivery order status`);
        }
        isError = false;
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setPayloads("errorMessage.view", {
          title: "Import Whatsapp Error",
          message:
            error?.response.status === 400
              ? "Gagal tambah sales order."
              : error?.response?.data?.message,
        });
        isError = true;
        openModal("errorMessage.view");
      }
    },
    onSuccess: () => {
      if (!isError) {
        handleSuccess();
      }
    },
  });

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const isCSV = file && file.name.endsWith('.csv'); // Check if the file is a CSV
    const reader = new FileReader();

    reader.onload = (event) => {
      const dataExcel = new Uint8Array(event.target.result);
      const workbook = XLSX.read(dataExcel, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const sheetData = XLSX.utils.sheet_to_json(sheet);

      let lastOrderId = null;
      let tempData = [];

      for (let index = 0; index < sheetData.length; index++) {
        const currentOrderId = sheetData[index]["Order ID"];
        const orderDate = isCSV
          ? excelDateToJSDate(sheetData[index]["Order Date"]) // Use excelDateToJSDate for CSV
          : new Date(sheetData[index]["Order Date"]); // Use standard date parsing for other formats
        const paidDate = isCSV
          ? excelDateToJSDate(sheetData[index]["Paid Date"]) // Use excelDateToJSDate for CSV
          : new Date(sheetData[index]["Paid Date"]); // Use standard date parsing for other formats

        if (!currentOrderId) {
          // If order_id is empty or undefined, use the last valid order_id
          let indexOf = tempData.map(elem => elem.order_id).indexOf(lastOrderId);
          tempData[indexOf]['items'].push(
            {
              product_name: sheetData[index]["Product Name"],
              variant: sheetData[index]["Variant"],
              price: sheetData[index]["Price"],
              qty: sheetData[index]["Amount"],
              sent_form: sheetData[index]["Sent From"],
              product_discount: sheetData[index]["Product Discount"],
            });
        } else {
          // Update lastOrderId with the current valid order_id
          lastOrderId = currentOrderId;
          tempData.push({
            order_id: sheetData[index]["Order ID"],
            order_date: orderDate,
            order_status: sheetData[index]["Order Status"],
            paid_date: paidDate,
            customer_name: sheetData[index]["Customer Name"],
            phone_number: sheetData[index]["Customer Phone Number"],
            total: sheetData[index]["Total Price"],
            shipping_cost: sheetData[index]["Shipping Cost"],
            insurance_fee: sheetData[index]["Insurance Fee"],
            shipping_discount: sheetData[index]["Shipping Discount"],
            special_discount: sheetData[index]["Special Discount"],
            point: sheetData[index]["Point"],
            items: [
              {
                product_name: sheetData[index]["Product Name"],
                variant: sheetData[index]["Variant"],
                price: sheetData[index]["Price"],
                qty: sheetData[index]["Amount"],
                sent_form: sheetData[index]["Sent From"],
                product_discount: sheetData[index]["Product Discount"],
              }
            ]
          });
        }
      }
      setData(tempData);
    };


    if (file) {
      reader.readAsArrayBuffer(file); // Use readAsArrayBuffer
    }
  }

  const downloadFailedData = () => {
    const tes = XLSX.utils.json_to_sheet(failedData);
    const ws = [
      ["Order Status", "Order ID", "Order Date", "Paid Date", "Total Price", "Customer Name", "Customer Phone Number", "Product Name", "Variant", "Price", "Amount", "Sent From", "Shipping Cost", "Insurance Fee", "Shipping Discount", "Special Discount", "Point"]
    ];

    for (let index = 0; index < failedData.length; index++) {
      if (failedData[index].items.length > 1) {
        console.log("items: ", failedData[index].items);
        for (let j = 0; j < failedData[index].items.length; j++) {
          ws.push([
            j === 0 ? failedData[index].order_status : "",
            j === 0 ? failedData[index].order_id : "",
            j === 0 ? failedData[index].order_date : "",
            j === 0 ? failedData[index].paid_date : "",
            j === 0 ? failedData[index].total : "",
            j === 0 ? failedData[index].customer_name : "",
            j === 0 ? failedData[index].phone_number : "",
            failedData[index].items[0].product_name,
            failedData[index].items[0].variant,
            failedData[index].items[0].price,
            failedData[index].items[0].qty,
            failedData[index].items[0].sent_form,
            j === 0 ? failedData[index].shipping_cost : "",
            j === 0 ? failedData[index].insurance_fee : "",
            j === 0 ? failedData[index].shipping_discount : "",
            j === 0 ? failedData[index].special_discount : "",
            j === 0 ? failedData[index].point : ""
          ]);
        }
      } else {
        ws.push([
          failedData[index].order_status,
          failedData[index].order_id,
          failedData[index].order_date,
          failedData[index].paid_date,
          failedData[index].total_price,
          failedData[index].customer_name,
          failedData[index].phone_number,
          failedData[index].items[0].product_name,
          failedData[index].items[0].variant,
          failedData[index].items[0].price,
          failedData[index].items[0].qty,
          failedData[index].items[0].sent_form,
          failedData[index].shipping_cost,
          failedData[index].insurance_fee,
          failedData[index].shipping_discount,
          failedData[index].special_discount,
          failedData[index].point
        ])
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(ws), "Failed Data");
    XLSX.writeFile(wb, "failed_data.xlsx");
  };

  return (
    <ModalMolecule
      show={showStates["salesOrder.importweb"]}
      title="Import Sales Order WEB"
      onClose={handleClose}
    >
      {isLoading && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-200 bg-opacity-50 z-50 flex justify-center items-center">
          <div className="bg-white p-4 rounded-md">
            <p>Loading...</p>
          </div>
        </div>
      )}
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form className="space-y-2" onSubmit={handleSubmit}>
            <>
              <div>Import Sales Order</div>
              <input data-testid="modal-import-sales-order-web-fileimport-input"
                type="file"
                name="fileImport"
                onChange={(e) => {
                  handleFileUpload(e);
                  setFieldValue("fileImport", e.currentTarget.files[0]);
                  // Set the file name here if needed
                }}
              />
              <p className="text-danger-600">
                {errors.fileImport && touched.fileImport && errors.fileImport}
              </p>
            </>
            <div>
              {
                processedData.length > 0 ? (
                  <div>
                    <h3>Processed Data:</h3>
                    <ul>
                      {processedData.map((row, index) => (
                        <li key={index}>Baris ke-{row.index} <Badge color={"green"}>{row.order_id}</Badge> <Badge color={"green"}>Success</Badge></li>
                      ))}
                    </ul>
                  </div>
                ) : null
              }
              {
                failedData.length > 0 ? (
                  <div>
                    <h3>Failed Data:</h3>
                    <ul>
                      {failedData.map((row, index) => (
                        <li key={index}>Baris ke-{row.index} <Badge color={"red"}>{row.errorMessage}</Badge> <Badge color={"red"}>Failed</Badge>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null
              }
            </div>
            {
              failedData.length > 0 ? (
                <OutlineButton testId="modal-import-sales-order-web-download-failed-data-button" type="button" onClick={downloadFailedData} className="btn btn-primary">
                  Download Failed Data
                </OutlineButton>
              ) : null
            }
            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-import-sales-order-web-import-button" type="submit">Import</Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}
export default ImportSalesOrderWeb;
